import { render, staticRenderFns } from "./RecordView.vue?vue&type=template&id=2d3c633c&scoped=true"
import script from "./RecordView.vue?vue&type=script&lang=js"
export * from "./RecordView.vue?vue&type=script&lang=js"
import style0 from "./RecordView.vue?vue&type=style&index=0&id=2d3c633c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c633c",
  null
  
)

export default component.exports